import React, { Component } from 'react';
import { connect } from 'react-redux';

function ScreenLoader(ComposedComponent) {
  @connect((store) => {
    return {
      loader: store.screenLoader,
    };
  })
  class ScreenLoading extends Component {
    render() {
      const { loader } = this.props;
      return (
        <div>
          {loader.Loading && (
            <div className="screen-loading" data-testid="screenLoader">
              <div class="lds-spinner">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
            </div>
          )}
          <ComposedComponent {...this.props} />
        </div>
      );
    }
  }

  return ScreenLoading;
}

export default ScreenLoader;
